import { TsUtils } from '@wix/answers-api';
import { Box, IconButton } from '@wix/design-system';
import { AddSmall } from '@wix/wix-ui-icons-common';
import React, { FunctionComponent } from 'react';

import { ApplySortAndFilterFn } from '..';
import { RoadmapSortAndFilter } from './../RoadmapSortAndFilter';
import { DATA_HOOKS } from '../../../dataHooks';
import { useResponsive } from '../../../hooks/useResponsive';
import {
  Label,
  RoadmapETAorVotedFilter,
  RoadmapFilter,
  SortAndFilterBiMetaData,
} from '../../../types';
import { useStore } from '../../../zustand/stores';
import { useRoadmapHeaderBi } from '../RoadmapHeader/bi';

import css from './index.module.scss';

export type RoadmapFiltersHeaderProps = {
  roadmapFilter: RoadmapFilter;
  onChangeRoadmapFilter: (filter: RoadmapFilter) => void;
  labels: Label[];
  apply: ApplySortAndFilterFn;
  onSearch: (text: string) => void;
  isScrolled: boolean;
  onChangeTriggerBiMetaData: (
    triggerBiMetaData: SortAndFilterBiMetaData
  ) => void;
  setShowDesktopOnlyModal: (showDesktopOnlyModal: boolean) => void;
  locale: string;
  setFeatureRequestModalVisible: (
    featureREquestModalVisible: boolean
  ) => Promise<void>;
};

export const allFilterOptions = TsUtils.enumToArray(
  RoadmapETAorVotedFilter
) as RoadmapETAorVotedFilter[];

export const RoadmapFiltersHeader: FunctionComponent<
  RoadmapFiltersHeaderProps
> = ({
  roadmapFilter,
  onChangeRoadmapFilter,
  labels,
  apply,
  isScrolled,
  onChangeTriggerBiMetaData,
  setShowDesktopOnlyModal,
  setFeatureRequestModalVisible,
}) => {
  const { isMobile } = useResponsive();
  const { isWixStudioUser } = useStore((state) => state.userSlice);
  const biLogger = useRoadmapHeaderBi();

  const onClickFeatureRequest = async () => {
    if (isMobile) {
      biLogger.onRequestFeatureClickFromMobile();
      setShowDesktopOnlyModal(true);
    } else {
      biLogger.onRequestFeatureClick();
      await setFeatureRequestModalVisible(true);
    }
  };

  return (
    <Box
      className={css.roadmapFilterHeader}
      align={isMobile ? 'right' : undefined}
    >
      <RoadmapSortAndFilter
        roadmapFilter={roadmapFilter}
        onChangeFilter={onChangeRoadmapFilter}
        productLabels={labels}
        applyValue={apply}
        isScrolled={isScrolled}
        onChangeTriggerBiMetaData={onChangeTriggerBiMetaData}
      />
      {isWixStudioUser && isMobile && (
        <IconButton
          onClick={onClickFeatureRequest}
          className={css.requestFeatureIconButton}
          dataHook={DATA_HOOKS.ROADMAP_FEATURE_REQUEST_BUTTON}
          priority="secondary"
          size="tiny"
        >
          <AddSmall height={'11px'} width={'11px'} />
        </IconButton>
      )}
    </Box>
  );
};
